<template>
  <div class="admin-page">
    <h2>Треки</h2>

    <p v-if="error" class="error-message">{{ error }}</p>

    <div class="panel">
      <p v-if="loading" class="empty-text">Загрузка...</p>
      <p v-else-if="tracks.length === 0" class="empty-text">Треков нет.</p>

      <div v-else class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th>Название</th>
              <th>Автор</th>
              <th>Публичный</th>
              <th>Архив</th>
              <th>Создан</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="track in tracks" :key="track.id">
              <td data-label="Название">
                <router-link :to="{ name: 'track', params: { id: track.id } }">
                  {{ track.name }}
                </router-link>
              </td>
              <td data-label="Автор">{{ track.user?.display_name || `Пользователь #${track.user_id}` }}</td>
              <td data-label="Публичный">{{ track.public ? 'Да' : 'Нет' }}</td>
              <td data-label="Архив">
                <span v-if="track.archived">Да, {{ formatDateTime(track.archived_at) }}</span>
                <span v-else>Нет</span>
              </td>
              <td data-label="Создан">{{ formatDateTime(track.created_at) }}</td>
              <td data-label="Действия">
                <div class="btn-row admin-actions">
                  <button
                    v-if="!track.archived"
                    type="button"
                    class="btn btn-secondary btn-sm"
                    :disabled="busyId === track.id"
                    @click="archiveTrack(track)"
                  >
                    В архив
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    :disabled="busyId === track.id"
                    @click="removeTrack(track)"
                  >
                    Удалить
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { archiveAdminTrack, destroyAdminTrack, fetchAdminTracks } from '../../api/admin'
import { extractApiError } from '../../utils/apiError'
import { formatDateTime } from '../../utils/formatDateTime'

const tracks = ref([])
const loading = ref(true)
const error = ref('')
const busyId = ref(null)

async function loadTracks() {
  loading.value = true
  error.value = ''
  try {
    tracks.value = await fetchAdminTracks()
  } catch (err) {
    error.value = extractApiError(err, 'Не удалось загрузить треки')
  } finally {
    loading.value = false
  }
}

function updateTrack(updated) {
  tracks.value = tracks.value.map((item) => (item.id === updated.id ? updated : item))
}

async function runAction(track, action) {
  busyId.value = track.id
  error.value = ''
  try {
    await action()
  } catch (err) {
    error.value = extractApiError(err)
  } finally {
    busyId.value = null
  }
}

async function archiveTrack(track) {
  if (!window.confirm(`Отправить трек «${track.name}» в архив?`)) return
  await runAction(track, async () => {
    const updated = await archiveAdminTrack(track.id)
    updateTrack(updated)
  })
}

async function removeTrack(track) {
  if (!window.confirm(`Удалить трек «${track.name}»? Это необратимо.`)) return
  await runAction(track, async () => {
    await destroyAdminTrack(track.id)
    tracks.value = tracks.value.filter((item) => item.id !== track.id)
  })
}

onMounted(loadTracks)
</script>
